module.exports = __webpack_public_path__ + "f369798d5c12c6510b4a70a7f21394f1.png";